import { observable } from '../lib/utils/observable.js?vue3';

export default observable('confidential_mr_state', {
  selectedProject: {},
});
